import { useState } from 'react';

export type ModalManagementResult = {
  closeArchiveModal: () => void;
  closeCategoryFormModal: () => void;
  closeDestroyModal: () => void;
  closeScheduleModal: () => void;
  closeVersionArchiveModal: () => void;
  closeVersionDestroyModal: () => void;
  isArchiveModalOpened: boolean;
  isCategoryFormModalOpened: boolean;
  isDestroyModalOpened: boolean;
  isScheduleModalOpened: boolean;
  isVersionArchiveModalOpened: boolean;
  isVersionDestroyModalOpened: boolean;
  openArchiveModal: () => void;
  openCategoryFormModal: () => void;
  openDestroyModal: () => void;
  openScheduleModal: () => void;
  openVersionArchiveModal: () => void;
  openVersionDestroyModal: () => void;
};

export default function useModalManagement(): ModalManagementResult {
  const [isCategoryFormModalOpened, setCategoryFormModalOpened] =
    useState(false);
  const [isDestroyModalOpened, setDestroyModalOpened] = useState(false);
  const [isVersionDestroyModalOpened, setVersionDestroyModalOpened] =
    useState(false);
  const [isArchiveModalOpened, setArchiveModalOpened] = useState(false);
  const [isVersionArchiveModalOpened, setVersionArchiveModalOpened] =
    useState(false);
  const [isScheduleModalOpened, setScheduleModalOpened] = useState(false);

  const closeArchiveModal = () => setArchiveModalOpened(false);
  const closeVersionArchiveModal = () => setVersionArchiveModalOpened(false);
  const closeCategoryFormModal = () => setCategoryFormModalOpened(false);
  const closeDestroyModal = () => setDestroyModalOpened(false);
  const closeVersionDestroyModal = () => setVersionDestroyModalOpened(false);
  const closeScheduleModal = () => setScheduleModalOpened(false);

  const openArchiveModal = () => setArchiveModalOpened(true);
  const openVersionArchiveModal = () => setVersionArchiveModalOpened(true);
  const openCategoryFormModal = () => setCategoryFormModalOpened(true);
  const openDestroyModal = () => setDestroyModalOpened(true);
  const openVersionDestroyModal = () => setVersionDestroyModalOpened(true);
  const openScheduleModal = () => setScheduleModalOpened(true);

  return {
    closeArchiveModal,
    closeCategoryFormModal,
    closeDestroyModal,
    closeScheduleModal,
    closeVersionArchiveModal,
    closeVersionDestroyModal,
    isArchiveModalOpened,
    isCategoryFormModalOpened,
    isDestroyModalOpened,
    isScheduleModalOpened,
    isVersionArchiveModalOpened,
    isVersionDestroyModalOpened,
    openArchiveModal,
    openCategoryFormModal,
    openDestroyModal,
    openScheduleModal,
    openVersionArchiveModal,
    openVersionDestroyModal,
  };
}
